import { omit } from "@/utils/utils";
import { v4 } from "uuid";

const omittedFields = [
  "__typename",
  "winning_revision_id",
  "winning_revision_author_id",
  "parent_id",
  "journal_author_id",
  "journal_created_at",
  "journal_updated_at",
  "journal_deleted_at",
  "winning_revision_created_at",
  "winning_revision_updated_at",
  "winning_revision_deleted_at",
  "winning_revision_parent_id"
];

export default function (
  data: Record<string, unknown> | undefined | null,
  additionalOmittedFields?: string[]
) {
  if (!data) return {};

  // Narrow for data that uses revision structure
  if ("winning_revision_id" in data) {
    const flatData = omit(data, (v, k) => {
      // Omit table relationships and nested data
      if ((k as string).startsWith("r_")) return true;
      // Omits all fields specified in omittedFields variable
      if (omittedFields.includes(k as string)) return true;
      if (additionalOmittedFields?.includes(k as string)) return true;
      return false;
    });
    return {
      ...flatData,
      id: v4(),
      journal_id: data.id || v4(),
      parent_revision_id: data.winning_revision_id,
      deleted_at: data.journal_deleted_at
    };
  } else {
    return omit(data, (v, k) => {
      // Omit table relationships and nested data
      if ((k as string).startsWith("r_")) return true;
      // Omits all fields specified in omittedFields variable
      if (omittedFields.includes(k as string)) return true;
      if (additionalOmittedFields?.includes(k as string)) return true;
      return false;
    }) as Record<string, unknown>;
  }
}
